import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { VISUALLY_HIDDEN } from "../visuallyHidden";
import s from "./Stepper.module.scss";

export type StepState = "done" | "current" | "todo";

type Props = {
  steps: { label: string; state: StepState }[];
  /** The list's name ("Steps"). */
  label: string;
  /** Said after a finished step's name, to screen readers only ("(done)"). */
  doneLabel: string;
};

/**
 * Board 27's step line: an `<ol>` (the list gives the order, so the numbers are decorative), the current step marked
 * with `aria-current="step"`, a finished one with a tick and hidden words — never by colour alone.
 */
export const Stepper = ({ steps, label, doneLabel }: Props) => (
  <ol aria-label={label} className={s.steps}>
    {steps.map((st, i) => (
      <li key={`${i}-${st.label}`} aria-current={st.state === "current" ? "step" : undefined} className={[s.step, s[st.state]].filter(Boolean).join(" ")}>
        <span aria-hidden className={s.mark}>{st.state === "done" ? <CheckRoundedIcon /> : i + 1}</span>
        <span className={s.label}>{st.label}{st.state === "done" && <span className={VISUALLY_HIDDEN}> {doneLabel}</span>}</span>
      </li>
    ))}
  </ol>
);
